import './PageDataComptes.css';

import PdcTable from '../PDC_table/PDC_table'
import PdcForm from '../PDC_form/PDC_form'


function PageDataComptes() {

    
    return (
        <div>
            <div><PdcTable /></div>
            <div><PdcForm /></div>
        </div>
    );
}

export default PageDataComptes

